import {ItemsTile} from './ItemsTile';

export class ItemsTileImageryProvider {
  public defaultAlpha = undefined;
  public defaultNightAlpha = undefined;
  public defaultDayAlpha = undefined;
  public defaultBrightness = undefined;
  public defaultContrast = undefined;
  public defaultHue = undefined;
  public defaultSaturation = undefined;
  public defaultGamma = undefined;
  public defaultMinificationFilter = undefined;
  public defaultMagnificationFilter = undefined;

  //public isUseColorBackground = true;
  public isUseColorBackground = false;

  private minShowLevel  = ItemsTile.DRAW_ZOOM;
  private maxShowLevel  = 28;
  private baseShowLevel = ItemsTile.DRAW_ZOOM;


  private cesiumAdapterService = undefined;

  // TODO: change, set ready only when needed tiles load
  private _readyPromise = Promise.resolve(true);
  private _tilingScheme = new Cesium.WebMercatorTilingScheme();
  // private _tilingScheme = new Cesium.GeographicTilingScheme();

  private _errorEvent = new Cesium.Event();
  private _tileWidth = 256; //ItemsTile.SIZE;
  private _tileHeight = 256; //ItemsTile.SIZE;

  constructor(cesiumAdapterService) {
    this.cesiumAdapterService = cesiumAdapterService;
  }

  get proxy() {
    return undefined;
  }

  get tileWidth() {
    return this._tileWidth;
  }

  get tileHeight() {
    return this._tileHeight;
  }

  get maximumLevel() {
    return undefined;
  }

  get minimumLevel() {
    return undefined;
  }

  get tilingScheme() {
    return this._tilingScheme;
  }

  get rectangle() {
    return this._tilingScheme.rectangle;
  }

  get tileDiscardPolicy() {
    return undefined;
  }

  get errorEvent() {
    return this._errorEvent;
  }

  get ready() {
    return true;
  }

  get readyPromise() {
    return this._readyPromise;
  }

  get credit() {
    return undefined;
  }

  get hasAlphaChannel() {
    return true;
  }

  public getTileCredits(
    x,
    y,
    level
  ) {
    return undefined;
  }

  private drawTileCanvasOld(context, x, y, offsetX = 0, offsetY = 0) {
    // console.log('[ITEMS CANVAS] drawTileCanvas this.isNeedRefresh, offsetX, offsetY', this.isNeedRefresh, offsetX, offsetY);
    context.font = 'bold 18px Monospace';

    let text = 'Label ' + 1;
    const textWidth = context.measureText(text).width;

    context.beginPath();
    context.strokeStyle = 'red';
    context.fillStyle = 'white';
    context.lineWidth = 2;
    context.ellipse(25 + textWidth + offsetX, 75 + offsetY, textWidth + 20, 25, 0, 0, 2 * Math.PI);
    context.fill();
    context.stroke();
    context.beginPath();
    context.ellipse(90 + textWidth + offsetX, 150 + offsetY, textWidth + 20, 25, 0, 0, 2 * Math.PI);
    context.fill();
    context.stroke();

    // X = previous X position + width + 25px margin

    context.textBaseline = 'middle'; //'alphabetic';
    context.textAlign = 'center';
    context.fillStyle = 'black';
    context.fillText(text, 25 + textWidth + offsetX, 75 + offsetY);
    context.fillText(text, 90 + textWidth + offsetX, 155 + offsetY);
    context.stroke();
  }

  private drawTileCanvas(context, x, y, offsetX = 0, offsetY = 0) {
    if (this.isUseColorBackground) {
      context.beginPath();
      const r = Math.floor(Math.random() * 255);
      const g = Math.floor(Math.random() * 255);
      const b = Math.floor(Math.random() * 255);
      context.fillStyle = `rgba(${r}, ${g}, ${b}, 0.3)`;
      context.fillRect(0, 0, ItemsTile.SIZE, ItemsTile.SIZE);
      context.fill();
    }

    // console.log('[ITEMS CANVAS] drawTileCanvas', x, y, offsetX, offsetY);
    this.cesiumAdapterService.itemsTilesManager.drawXYTile(context, x, y, offsetX, offsetY);
  }

  private drawTile(x, y, scale, context) {
    // console.log('[ITEMS CANVAS] drawTile: x, y, scale', x, y, scale);
    if (scale >= 1) {
      const labelContext = context;

      const xi = x % scale;
      const yj = y % scale;
      const size = ItemsTile.SIZE / scale;
      const offsetX = -size * xi;
      const offsetY = -size * yj;

      labelContext.scale(scale, scale);
      // console.log('[ITEMS CANVAS] xi, yj', xi, yj);

      this.drawTileCanvas(labelContext, Math.floor(x / scale), Math.floor(y / scale), offsetX,  offsetY);
    } else {
      const count = Math.round(1 / scale);

      const labelCanvas = document.createElement("canvas");
      const labelContext = labelCanvas.getContext('2d');
      const size = ItemsTile.SIZE * scale;
      labelCanvas.width = size;
      labelCanvas.height = size;

      labelContext.scale(scale, scale);
      // console.log('[ITEMS CANVAS] count, size', count, size);

      for (let xi = 0; xi < count; xi++) {
        for (let yj = 0; yj < count; yj++) {
          labelContext.clearRect(0, 0, ItemsTile.SIZE, ItemsTile.SIZE);

          this.drawTileCanvas(labelContext, Math.floor(x / scale) + xi, Math.floor(y / scale) + yj);
          context.drawImage(labelCanvas, size * xi, size * yj, size, size);
        }
      }

    }

    // console.timeEnd('[ITEMS CANVAS] drawTile');
  }

  public requestImage(
    x,
    y,
    level,
    request
  ) {
    // console.log('[ITEMS CANVAS], currentZoom, level', this.cesiumAdapterService.currentZoom, level);

    if (level >= this.minShowLevel) {

      const scale = this.getScale(level);
      const xdl = Math.floor(x / scale);
      const ydl = Math.floor(y / scale);

      if (
        this.cesiumAdapterService.itemsTilesManager && 
        this.cesiumAdapterService.itemsTilesManager.hasTile(xdl, ydl)
      ) {
        const canvas = document.createElement("canvas");
        canvas.width = ItemsTile.SIZE;
        canvas.height = ItemsTile.SIZE;
        const context = canvas.getContext("2d");
        this.drawTile(x, y, scale, context);

        return Promise.resolve(canvas);
      }
    }

    const canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = 1;
    return Promise.resolve(canvas);
  }

  private getScale(level) {
    if (level < this.minShowLevel || level > this.maxShowLevel) {
      return 1;
    }
    const pow = level - this.baseShowLevel;
    return Math.pow(2, pow);
  }

  public pickFeatures(
    x,
    y,
    level,
    longitude,
    latitude
  ) {
    return undefined;
  }

  private addCache(x, y, level, ) {

  }
}
